const UnderConstruction =()=>
{
    return <>
    <p>This page is under construction</p>
    </>;
};

export default UnderConstruction;